<h4
    *ngIf="options.length === 0"
    class="d-flex h-100 justify-content-center align-items-center"
>
    <ng-container [ngTemplateOutlet]="emptyState">
    </ng-container>
</h4>
<ng-container
    *ngIf="options.length > 0"
    [ngTemplateOutlet]="content"
>
</ng-container>

<ng-template #emptyState>
    <span class="text-muted">
        No times available
    </span>
</ng-template>

<ng-template #content>
     
    <div class="vstack gap-2 overflow-auto">
        <div class="vstack overflow-auto">
        
            <!-- Mobile: scrollable container with all options -->
            <div class="d-sm-none overflow-y-auto overflow-x-hidden">
                <div class="row g-2">
                    <div
                        *ngFor="let option of options"
                        class="col-6"
                    >
                        <label
                            class="btn btn-outline-secondary p-2 d-flex flex-column justify-content-center align-items-center w-100"
                            [class.disabled]="!option.isReservable && !option.isWaitlistOnly"
                            [attr.data-testid]="option.isWaitlistOnly ? 'waitlist-time-option' : 'time-option'"
                        >
                            <div class="m-1 hstack gap-2">
                                <input
                                    type="radio"
                                    [value]="option.start"
                                    (change)="selectOption(option)"
                                    class="form-check-input m-0"
                                    role="button"
                                >
                                <div class="vstack align-items-start">
                                    <span class="fw-semibold">
                                        <i *ngIf="option.isWaitlistOnly" class="bi bi-clock me-1"></i>
                                        {{ option.start | ngbTime | date: 'shortTime' }}
                                    </span>
                                    <span
                                        *ngIf="!option.isReservable && !option.isWaitlistOnly"
                                        class="small"
                                    >
                                        Unavailable
                                    </span>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <!-- Desktop: paginated view with responsive grid -->
            <div class="d-none d-sm-block overflow-hidden">
                <div class="row g-2">
                    <div
                        *ngFor="let option of options | paginate: pageConfig"
                        class="col-4"
                    >
                        <label
                            class="btn btn-outline-secondary p-2 d-flex flex-column justify-content-center align-items-center w-100"
                            [class.disabled]="!option.isReservable && !option.isWaitlistOnly"
                            [attr.data-testid]="option.isWaitlistOnly ? 'waitlist-time-option' : 'time-option'"
                        >
                            <div class="m-1 hstack gap-2">
                                <input
                                    type="radio"
                                    [value]="option.start"
                                    (change)="selectOption(option)"
                                    class="form-check-input m-0"
                                    role="button"
                                >
                                <div class="vstack align-items-start">
                                    <span class="fw-semibold">
                                        <i *ngIf="option.isWaitlistOnly" class="bi bi-clock me-1"></i>
                                        {{ option.start | ngbTime | date: 'shortTime' }}
                                    </span>
                                    <span
                                        *ngIf="!option.isReservable && !option.isWaitlistOnly"
                                        class="small"
                                    >
                                        Unavailable
                                    </span>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div
            *ngIf="hasWaitlistOptions"
            class="small text-muted hstack gap-1 justify-content-center"
            data-testid="waitlist-slots-explanation"
        >
            <i class="bi bi-clock"></i>
            <span>Some times are fully booked, but you can join the waitlist</span>
        </div>
        <div class="d-none d-sm-block">
            <ng-container
                *ngTemplateOutlet="paginationToolbar"
            >
            </ng-container>
        </div>
    </div>
</ng-template>


<ng-template #paginationToolbar>
    <div
        *ngIf="pageConfig.itemsPerPage < pageConfig.totalItems"
        class="bg-white mt-auto"
    >
        <hr class="m-0"/>
        <div
            class="hstack gap-2 justify-content-between"
            pagination-template
            #p="paginationApi"
            (pageChange)="pageConfig.currentPage = $event"
        >
            <button
                class="btn btn-sm btn-outline-secondary"
                data-testid="earlier-booking-slot"
                [class.disabled]="p.isFirstPage()"
                [disabled]="p.isFirstPage()"
                (click)="p.previous()"
            >
                <i class="bi bi-chevron-left"></i>
                Earlier
            </button>
            <div class="d-none d-sm-flex hstack flex-grow-1 flex-wrap justify-content-center">
                <div
                    *ngFor="let page of p.pages"
                    [class.current]="p.getCurrent() === page.value"
                >
                    <a
                        *ngIf="p.getCurrent() !== page.value"
                        role="button"
                        class="p-2 text-decoration-none"
                        (click)="p.setCurrent(page.value)"
                    >
                        <span class="text-secondary">
                            {{ page.label }}
                        </span>
                    </a>
                    <div
                        *ngIf="p.getCurrent() === page.value"
                        class="p-2"
                    >
                        <span class="fw-semibold">
                            {{ page.label }}
                        </span>
                    </div>
                </div>
            </div>
            <button
                class="btn btn-sm btn-outline-secondary"
                data-testid="later-booking-slot"
                [class.disabled]="p.isLastPage()"
                [disabled]="p.isLastPage()"
                (click)="p.next()"
            >
                Later
                <i class="bi bi-chevron-right"></i>
            </button>
        </div>
    </div>
</ng-template>
